import React, { useEffect, useState } from 'react';
import '../App.css';
import { Button } from './Button';
import './HeroSection.css';

function HeroSection() {
  const [isDesktop, setIsDesktop] = useState(true);

  useEffect(() => {
    const checkScreenSize = () => {
      setIsDesktop(window.innerWidth > 1000);
    };

    checkScreenSize();
    window.addEventListener('resize', checkScreenSize);

    return () => window.removeEventListener('resize', checkScreenSize);
  }, []);

  return (
    <div className='hero-container'>
      {isDesktop ? (
        <video className='hero-bg' src='/images/vid-home.mp4' autoPlay loop muted playsInline />
      ) : (
        <img className='hero-bg' src='/images/img-home.jpg' alt='' />
      )}

        <h1>DRIVEN BY PASSION, GUIDED BY VISION</h1>
        <div className='hero-btns'>
            <Button className='btns' buttonStyle='btn--outline' buttonSize='btn--large' to='/portfolio'>
                EXPLORE PORTFOLIO
            </Button>
            <Button className='btns' buttonStyle='btn--outline' buttonSize='btn--large' to='/inquire'>
                BOOK A PHOTOSHOOT
            </Button>
        </div>
    </div>
  )
}

export default HeroSection;
